export const PASSWORD_RULES = [
  { re: /.{8,}/,         label: '8+ characters'           },
  { re: /[A-Z]/,         label: 'One uppercase letter'    },
  { re: /[0-9]/,         label: 'One number'              },
  { re: /[^A-Za-z0-9]/, label: 'One special character'   },
];

export function checkPassword(password) {
  return PASSWORD_RULES.map(rule => ({
    label: rule.label,
    passed: rule.re.test(password),
  }));
}

export function isPasswordValid(password) {
  return PASSWORD_RULES.every(rule => rule.re.test(password));
}
